import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { AnonymousIdentity } from './Identity';
import glue from '../glue';
import { EventManager } from '../utils';
/**
 * Database authentication is an authentication by cookie and username password.
 */

export var DatabaseAuthentication = /*#__PURE__*/function () {
  function DatabaseAuthentication() {
    _classCallCheck(this, DatabaseAuthentication);

    this.eventManager = new EventManager();
  }

  _createClass(DatabaseAuthentication, [{
    key: "currentUser",
    get: function get() {
      return this._currentUser;
    }
  }, {
    key: "setCurrentUser",
    set: function set(value) {
      this._currentUser = value;
    }
  }, {
    key: "authenticate",
    value: function authenticate(request) {
      request.credentials = 'include';
      return request;
    }
  }, {
    key: "login",
    value: function login() {
      glue.browserHistory.push('/login', {
        redirect: glue.browserHistory.location.pathname
      });
    }
  }, {
    key: "loginWith",
    value: function loginWith(username, password) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var params, identityRequest;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                params = new URLSearchParams();
                params.append('username', username);
                params.append('password', password);
                _context.next = 6;
                return glue.api.post('/api/auth/login', params);

              case 6:
                _context.next = 8;
                return glue.api.get('/api/me', {
                  maxRedirects: 0
                });

              case 8:
                identityRequest = _context.sent;

                if (200 === identityRequest.status) {
                  this._currentUser = identityRequest.data;
                  this.eventManager.fire('login');
                }

                return _context.abrupt("return", this._currentUser);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                throw new Error('Failed authentication');

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));
    }
  }, {
    key: "logout",
    value: function logout() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return glue.api.post('/api/auth/logout');

              case 2:
                this._currentUser = new AnonymousIdentity();
                this.eventManager.fire('logout');
                return _context2.abrupt("return", undefined);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "on",
    value: function on(eventKind, callback) {
      return this.eventManager.addListener(eventKind, callback);
    }
  }, {
    key: "init",
    value: function init(glue) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var authRequest;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return glue.api.get('/api/me', {
                  maxRedirects: 0
                });

              case 3:
                authRequest = _context3.sent;

                if (200 === authRequest.status) {
                  this._currentUser = authRequest.data;
                }

                _context3.next = 9;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

              case 9:
                return _context3.abrupt("return", this);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));
    }
  }]);

  return DatabaseAuthentication;
}();